module.exports = "img/flags/NL.f9db532.png";